import { render, staticRenderFns } from "./widget-text.vue?vue&type=template&id=4c90ed5c&scoped=true"
import script from "./widget-text.vue?vue&type=script&lang=js"
export * from "./widget-text.vue?vue&type=script&lang=js"
import style0 from "./widget-text.vue?vue&type=style&index=0&id=4c90ed5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c90ed5c",
  null
  
)

export default component.exports